import { useMutation } from '@tanstack/react-query';
import apiClient from '../libs/apiClient';
import { AccessLink, SendAccessLinkParams } from '../types/accessLink';
import { ApiResponse } from '../types/response';

const sendAccessLink = async (params: SendAccessLinkParams) => {
  const {
    data: { data },
  } = await apiClient.post<ApiResponse<AccessLink>>('/access-link/send-sms', params);
  return data;
};

const useSendAccess = () => {
  return useMutation({
    mutationFn: sendAccessLink,
  });
};

export default useSendAccess;
